module.exports = __webpack_public_path__ + "img/logo-half-top.8908be85.png";